// extracted by mini-css-extract-plugin
module.exports = {"label":"Quantities_label__2iR6k"};